import { Popconfirm as AntdPopconfirm } from 'antd';

import styles from './popConfirm.module.scss';
import Button from '../button';

const Popconfirm = ({
	disabled,
	icon,
	title,
	description,
	onConfirm,
	onCancel,
	children,
	cancelText,
	okText,
	okButtonColor,
	open,
	okButtonLoading,
	placement,
	onOpenChange,
	zIndex = 1050,
}) => {
	return (
		<AntdPopconfirm
			disabled={disabled}
			icon={icon}
			showCancel={false}
			okButtonProps={{ style: { display: 'none' } }}
			open={open}
			onOpenChange={onOpenChange}
			placement={placement}
			zIndex={zIndex}
			title={<p className={styles['popconfirm-title']}>{title}</p>}
			description={
				<>
					<p className={styles['popconfirm-description']}>{description}</p>
					<div className={styles['footer-buttons']}>
						<Button size="small" onClick={onCancel} type="bordered">
							{cancelText}
						</Button>
						<Button
							onClick={onConfirm}
							size="small"
							color={okButtonColor}
							loading={okButtonLoading}
						>
							{okText}
						</Button>
					</div>
				</>
			}
		>
			{children}
		</AntdPopconfirm>
	);
};

export default Popconfirm;
